import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { useGetTemporaryAuthenticationToken } from 'js/hooks/auth';

export const useSportsbookGetTemptoken = () => {
    const { userName, isLoggedIn, sessionStartTime } = useUserSelector(pick(['userName', 'isLoggedIn', 'sessionStartTime']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();

    return useCallback(async () => {
        if (isLoggedIn) {
            const token = await getTemporaryAuthenticationToken();

            return { userName, token, sessionCreationTime: new Date(sessionStartTime).toISOString() };
        }

        return null;
    }, [getTemporaryAuthenticationToken, isLoggedIn, userName, sessionStartTime]);
};
